export default __webpack_public_path__ + "static/media/a020-it-4.1d9744ef.svg";